import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    LogOut_Clear: state => {
      localStorage.removeItem("loginToken");
      localStorage.removeItem("tokenExpires");
      localStorage.removeItem("userInfo");
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    LogOut({ commit }) {
      commit('LogOut_Clear')
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js